import { z } from 'zod';
/**
 * Abonnierte externe iCal-Kalender (Müll, Feiertage, Ferien). URL wird periodisch
 * abgerufen; die enthaltenen Termine erscheinen schreibgeschützt im
 * Familienkalender (ADR: iCal-Abos). Nur Erwachsene verwalten Abos.
 */
const hexColor = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'Farbe als #rrggbb');
/** Erlaubt http(s):// und webcal:// (wird serverseitig zu https normalisiert). */
const icalUrl = z
    .string()
    .trim()
    .max(2000)
    .refine((s) => /^(https?|webcal):\/\//i.test(s), 'URL muss mit http(s):// oder webcal:// beginnen');
export const calendarSubscriptionDtoSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    url: z.string(),
    color: z.string(),
    enabled: z.boolean(),
    eventCount: z.number().int(),
    lastSyncAt: z.string().nullable(),
    lastError: z.string().nullable(),
    // ADR-089 — optional, damit ältere Server/Clients kompatibel bleiben.
    renderAsBackground: z.boolean().optional(),
    defaultReminderMinutes: z.number().int().nullable().optional(),
    presetKey: z.string().nullable().optional(),
});
export const createCalendarSubscriptionSchema = z.object({
    name: z.string().trim().min(1).max(80),
    url: icalUrl,
    color: hexColor,
    enabled: z.boolean().optional(),
    // Feiertage/Ferien als dezente Hintergrundmarkierung statt Balken (ADR-089).
    renderAsBackground: z.boolean().optional(),
    // Standard-Erinnerung für alle Termine dieses Abos (Minuten vorher, null = aus).
    defaultReminderMinutes: z.number().int().min(0).max(40320).nullable().optional(),
    presetKey: z.string().max(60).nullable().optional(),
});
export const updateCalendarSubscriptionSchema = createCalendarSubscriptionSchema.partial();
/**
 * Vorlage für „Abo hinzufügen" (ADR-089). Liefert der Server unter
 * GET /api/calendar-subscriptions/presets — so lassen sich Presets ohne neuen
 * App-Build erweitern. `url` kann {FROM}/{TO} (YYYY-MM-DD) enthalten; der Server
 * setzt beim Abruf das aktuelle Sync-Fenster ein. url = '' → Nutzer trägt sie ein.
 */
export const calendarPresetSchema = z.object({
    key: z.string(),
    group: z.string(), // z. B. "Feiertage", "Schulferien", "Sonstiges"
    name: z.string(),
    url: z.string(),
    color: hexColor,
    renderAsBackground: z.boolean(),
    hint: z.string().optional(),
});
//# sourceMappingURL=subscription.js.map